import React from 'react';
import styles from './Services.module.css';
import useReveal from './useReveal';

const services = [
  {
    num: '01', icon: '🏗️', name: 'Full-Stack Web Development',
    desc: 'Powerful, scalable web applications and platforms tailored to your exact business needs with modern architecture.',
    tags: ['Websites', 'Web Apps', 'SaaS', 'E-commerce'],
  },
  {
    num: '02', icon: '🎨', name: 'Frontend Development',
    desc: 'Modern, visually engaging interfaces that deliver seamless user experiences across all devices and screen sizes.',
    tags: ['React', 'Next.js', 'UI/UX', 'Responsive'],
  },
  {
    num: '03', icon: '⚙️', name: 'Backend Development',
    desc: 'Robust backend systems built to handle high traffic, secure data, and ensure reliable performance at scale.',
    tags: ['REST APIs', 'Auth Systems', 'Databases'],
  },
  {
    num: '04', icon: '🔍', name: 'SEO & Website Ranking',
    desc: 'Advanced SEO strategies to rank higher on search engines and attract organic, high-intent traffic to your business.',
    tags: ['Technical SEO', 'On-page', 'Local SEO'],
  },
  {
    num: '05', icon: '📢', name: 'Google Ads & Marketing',
    desc: 'Data-driven advertising campaigns that generate quality leads, increase conversions and maximize ROI.',
    tags: ['Search Ads', 'Display Ads', 'Lead Gen'],
  },
  {
    num: '06', icon: '📱', name: 'Social Media Management',
    desc: 'Build strong brands and engage your audience across Instagram, Facebook, LinkedIn, and Twitter.',
    tags: ['Strategy', 'Content', 'Analytics'],
  },
  {
    num: '07', icon: '📍', name: 'Google Business Profile',
    desc: 'Optimize your local presence and appear in Google Maps and local search results to attract more customers.',
    tags: ['Setup', 'Optimization', 'Reviews'],
  },
  {
    num: '08', icon: '🛡️', name: 'Website Maintenance',
    desc: 'Ongoing support, security updates, speed optimization and feature enhancements to keep your digital systems performing.',
    tags: ['Security', 'Speed', 'Support'],
  },
];

export default function Services() {
  const headRef = useReveal();

  return (
    <section className={styles.services} id="services">
      <div className={`reveal ${styles.head}`} ref={headRef}>
        <span className="section-label">// our services</span>
        <h2 className="section-title">
          Complete <em>Digital Stack</em><br />for Your Business
        </h2>
        <p className="section-sub">
          From development to marketing — one agency, all services, measurable results.
        </p>
      </div>

      <div className={styles.grid}>
        {services.map((s) => (
          <ServiceCard key={s.num} service={s} />
        ))}
      </div>
    </section>
  );
}

function ServiceCard({ service }) {
  const ref = useReveal();
  return (
    <div className={`reveal ${styles.card}`} ref={ref}>
      <span className={styles.num}>{service.num} /</span>
      <span className={styles.icon}>{service.icon}</span>
      <h3 className={styles.name}>{service.name}</h3>
      <p className={styles.desc}>{service.desc}</p>
      <div className={styles.tags}>
        {service.tags.map((t) => <span key={t} className={styles.tag}>{t}</span>)}
      </div>
    </div>
  );
}
